// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import SplitOrderCartLineState from "@store/Framework/Store/Greif/Pages/ReviewAndSubmit/SplitOrderCartLine/SplitOrderCartLineState";
import { Draft } from "immer";

const initialState: SplitOrderCartLineState = {
    isUpdatingNotes: false,
    failedToUpdateSplitOrderCartLine: false,
};

const actions = {
    "Greif/Pages/ReviewAndSubmit/BeginUpdateSplitOrderCartLine": (draft: Draft<SplitOrderCartLineState>) => {
        draft.isUpdatingNotes = true;
    },
    "Greif/Pages/ReviewAndSubmit/CompleteUpdateSplitOrderCartLine": (draft: Draft<SplitOrderCartLineState>) => {
        draft.isUpdatingNotes = false;

        if (draft.failedToUpdateSplitOrderCartLine) {
            draft.failedToUpdateSplitOrderCartLine = false;
        }
    },
    "Greif/Pages/ReviewAndSubmit/FailedToUpdateSplitOrderCartLine": (draft: Draft<SplitOrderCartLineState>) => {
        draft.failedToUpdateSplitOrderCartLine = true;
        draft.isUpdatingNotes = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifSubmitAndReviewPagesReducerSplitOrderCartLineActions = Parameters<typeof reducer>[1];
export default reducer;
